export default __webpack_public_path__ + "static/media/DS Smith.16b9b874.png";